<template>
  <div class="briefs-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :filtroPeriodo="filtroPeriodo"
          :filtroNumero="filtroNumero"
          :filtroPresupuesto="filtroPresupuesto"
          :fechaDesde="new Date(fechaDesde)"
          :fechaHasta="new Date(fechaHasta)"
          :cliente="cliente"
          :numero="numero"
          :numeroPI="numeroPI"
          :incluirCerrados="incluirCerrados"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Briefs de Diseño">
          <b-table hover
              responsive 
              class="registro"
              :busy="tableBusy"
              :items="briefs" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
              <!-- {{ data.item.fechaRegistro | fechaHora }} -->
            </template>
            <template v-slot:cell(fechaUltimaEdicion)="data">
              {{ data.item.fechaUltimaEdicion | fecha }}
              <!-- {{ data.item.fechaUltimaEdicion | fechaHora }} -->
            </template>
            <template v-slot:cell(isCerrado)="data">
              {{ data.item.isCerrado? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item
                    v-if="opcionEditarBrief"
                    :disabled="data.item.isCerrado"
                    @click.stop="editarItem(data.item)">
                  <i class="fa fa-edit"></i>Editar Brief de Diseño</b-dropdown-item>
                <b-dropdown-item 
                    v-if="opcionCancelarBrief"
                    :disabled="data.item.isCerrado"
                    @click.stop="cancelar(data.item)">
                  <i class="fa fa-remove"></i>Cancelar Brief de Diseño</b-dropdown-item>
                <b-dropdown-item 
                    v-if="opcionCerrarBrief && !data.item.isCerrado"
                    @click.stop="cerrar(data.item)">
                  <i class="fa fa-lock"></i>Cerrar Brief de Diseño</b-dropdown-item>
                <b-dropdown-item 
                    v-if="opcionAbrirBrief && data.item.isCerrado"
                    @click.stop="abrir(data.item)">
                  <i class="fa fa-unlock"></i>Abrir Brief de Diseño</b-dropdown-item>
                <b-dropdown-item 
                    v-if="opcionAddPresupuesto && !data.item.tienePresupuestosInternos"
                    @click.stop="addPresupuesto(data.item)">
                  <i class="fa fa-plus"></i>Generar Presupuesto Interno</b-dropdown-item>
                <b-dropdown-item 
                    v-if="opcionAddPresupuesto"
                    :disabled="data.item.isCerrado"
                    @click.stop="asociarPresupuesto(data.item)">
                  <i class="fa fa-plus"></i>Asociar Presupuesto Interno</b-dropdown-item>

                <b-dropdown-divider v-if="opcionAsignacionUsuarios"></b-dropdown-divider>
                <b-dropdown-item 
                    v-if="opcionAsignacionUsuarios"
                    :disabled="data.item.isCerrado"
                    @click.stop="asignarUsuarios(data.item)">
                  <i class="fa fa-users"></i>Asignar Usuarios</b-dropdown-item>

                <b-dropdown-divider v-if="opcionAddSolicitudAdicionales || opcionAddSolicitudCambios"></b-dropdown-divider>

                <b-dropdown-item 
                    v-if="opcionAddSolicitudAdicionales"
                    :disabled="data.item.isCerrado"
                    @click.stop="adicionalesBrief(data.item)">
                  <i class="fa fa-edit"></i>Solicitud de Adicionales</b-dropdown-item>

                <b-dropdown-item 
                    v-if="opcionAddSolicitudCambios"
                    :disabled="data.item.isCerrado"
                    @click.stop="cambiosBrief(data.item)">
                  <i class="fa fa-edit"></i>Solicitud de Cambios</b-dropdown-item>
                
                <b-dropdown-divider/>
                <b-dropdown-item 
                    @click.stop="emitirRpt(data.item)">
                  <i class="fa fa-file-pdf-o"></i>Emitir Brief</b-dropdown-item>
                <b-dropdown-item 
                    @click.stop="emitirRptCambios(data.item)">
                  <i class="fa fa-file-pdf-o"></i>Emitir Resumen de Cambios</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <!-- <b-modal ref="cambiosModal"
        title="Cambios"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-cambios
        @registrarCambios="registrarCambios"
        @cancelarCambios="cancelarCambios">
      </app-cambios>  
    </b-modal> -->

    <b-modal ref="observacionesModal"
        title="Cancelación del Brief"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-observaciones
        @save="saveCancelacion"
        @cancelar="cancelarCancelacion">
      </app-observaciones>  
    </b-modal>

    <!-- <div class="fixed-btn" v-if="opcionAgregarBrief">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div> -->

    <div class="fixed-btn" v-if="opcionAgregarBrief || opcionExportarListado">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item 
              v-if="opcionAgregarBrief"
              @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Brief</b-dropdown-item>
          <b-dropdown-item 
              v-if="opcionExportarListado"
              @click.stop="exportar">
            <i class="fa fa-file-excel-o"></i>Exportar Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="searchPresupuestoInternoModal" 
        title="Seleccionar Presupuesto Interno"
        header-bg-variant="light" 
        hide-footer
        lazy
        modal-class="modalABM modalSearchPresupuesto">
      <app-search-presupuesto
        :soloPresupuestosAbiertos="true"
        :seleccionarOrden="false"
        :seleccionarSubtrabajo="false"
        @presupuestoInternoSeleccionado="presupuestoInternoSeleccionado"
        @cancelaSeleccionPresupuestoInterno="cancelaSeleccionPresupuestoInterno">
      </app-search-presupuesto>  
    </b-modal>

    <b-modal ref="usuariosSeleccionModal" 
        title="Asignación de Usuarios"
        header-bg-variant="light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-usuarios-seleccion
        :briefId="briefId"
        @close="closeUsuariosSeleccion">
      </app-usuarios-seleccion>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
// import Cambios from './CambiosAdd.vue'
import Observaciones from  '../shared/observacionesModal.vue';
import Filtro from './listFiltro.vue';
import SearchPresupuesto from '../presupuestosinternos/Search.vue';
import UsuariosSeleccion from './UsuariosSeleccion.vue';
import exportPDFBrief from '../../mixins/export_brief_pdf';
import exportPDFBriefCambios from '../../mixins/export_brief_cambios_pdf';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefs/getField',
  mutationType: 'briefs/updateField',
});

export default {
  name: 'BriefsList',
  components: {
    // appCambios: Cambios,
    appObservaciones: Observaciones,
    appFiltro: Filtro,
    appSearchPresupuesto: SearchPresupuesto,
    appUsuariosSeleccion: UsuariosSeleccion,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
    exportPDFBrief,
    exportPDFBriefCambios 
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'id',
          label: 'Nro.',
        },
        {
          key: 'fechaRegistro',
        },
        {
          key: 'fechaUltimaEdicion',
          label: 'Ult.Modificación'
        },
        {
          key: 'presupuestosInternosNumeros',
          // key: 'presupuestoNumero',
          label: 'Nro.Presup.'
        },
        {
          key: 'cliente',
        },
        {
          key: 'accion',
        },
        {
          key: 'usuario',
          label: 'Creado'
        },
        {
          key: 'isCerrado',
          label: 'Cerrado',
          class: 'text-center',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      briefId: 0,
      tableBusy: false,
      opcionAgregarBrief: false,
      opcionEditarBrief: false,
      opcionCancelarBrief: false,
      opcionAddPresupuesto: false,
      opcionAddSolicitudAdicionales: false,
      opcionAddSolicitudCambios: false,
      opcionAsignacionUsuarios: false,
      opcionCerrarBrief: false,
      opcionAbrirBrief: false,
      opcionExportarListado: false
    }
  },
  computed: {
    ...mapFields([
      'briefs',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'filtroPeriodo',
      'filtroNumero',
      'filtroPresupuesto',
      'fechaDesde',
      'fechaHasta',
      'cliente',
      'numero',
      'numeroPI',
      'incluirCerrados',
      'sortByDescending',
    ]),
  },
  created() {
    let route = this.$router.resolve({ name: 'BriefAdd', params: { id: -1 } }).route;
    this.opcionAgregarBrief = Boolean(this.$store.getters['user/tieneAcceso'](route));
    route = this.$router.resolve({ name: 'BriefEdit', params: { id: -1 } }).route;
    this.opcionEditarBrief = Boolean(this.$store.getters['user/tieneAcceso'](route));
    route = this.$router.resolve({ name: 'BriefAdicionalesAdd', params: { id: -1 } }).route;
    this.opcionAddSolicitudAdicionales = Boolean(this.$store.getters['user/tieneAcceso'](route));
    route = this.$router.resolve({ name: 'BriefCambiosAdd', params: { id: -1 } }).route;
    this.opcionAddSolicitudCambios = Boolean(this.$store.getters['user/tieneAcceso'](route));
    
    this.opcionCancelarBrief = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsCancelar'));
    this.opcionAddPresupuesto = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsAgregarPresupuesto'));
    // this.opcionAddSolicitudCambios = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsSolicitudesCambios'));
    this.opcionAsignacionUsuarios = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsAsignacionUsuarios'));
    this.opcionCerrarBrief = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsCerrar'));
    this.opcionAbrirBrief = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsAbrir'));
    this.opcionExportarListado = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsExportarListado'));

    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.filtroPeriodo = filtro.filtroPeriodo;
      this.filtroNumero = filtro.filtroNumero;
      this.filtroPresupuesto = filtro.filtroPresupuesto;
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.cliente = filtro.cliente;
      this.numero = parseInt(filtro.numero);
      this.numeroPI = parseInt(filtro.numeroPI);
      this.incluirCerrados = filtro.incluirCerrados;
      this.sortByDescending = filtro.sortByDescending;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('briefs/getBriefs')
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.tableBusy = false);
    },
    consultar (item) {
      this.$router.push({ name: 'BriefData', 
                          params: { id: item.id }});
    },
    editarItem (item) {
      this.$router.push({ name: 'BriefEdit', 
                          params: { id: item.id }});
    },
    agregar() {
      this.$router.push({ name: 'BriefAdd' }); 
    },
    adicionalesBrief(item) {
      this.$router.push({ name: 'BriefAdicionalesAdd', 
                          params: { id: item.id }});
    },
    cambiosBrief(item) {
      this.$router.push({ name: 'BriefCambiosAdd', 
                          params: { id: item.id }});
    },
    emitirRpt(item) {
      let empresa = {};
      this.showSpinner();
      this.$store.dispatch('empresa/inicializar')
        .then(() => {
          empresa = this.$store.getters['empresa/empresa'];
          return;
        })
        .then(() => {
          return this.$store.dispatch('briefDatos/getBrief', item.id);
        })
        .then(() => {
          let brief = this.$store.getters['briefDatos/briefDatos'];

          this.exportPDFBrief(brief, empresa);
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    emitirRptCambios(item) {
      let empresa = {};
      this.showSpinner();
      this.$store.dispatch('empresa/inicializar')
        .then(() => {
          empresa = this.$store.getters['empresa/empresa'];
          return;
        })
        .then(() => {
          return this.$store.dispatch('briefDatos/getRptBriefCambios', item.id);
        })
        .then(() => {
          let brief = this.$store.getters['briefDatos/briefCambios'];

          this.exportPDFBriefCambios(brief, empresa);
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelar(item) {
      this.briefId = item.id;
      this.$refs.observacionesModal.show();
    },
    saveCancelacion(params) {
      this.$refs.observacionesModal.hide();

      params.briefId = this.briefId;

      this.showSpinner();
      this.$store.dispatch('briefs/cancelarBrief', params)
        .then(() => this.showModalMsj('El brief seleccionado se canceló con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelarCancelacion() {
      this.$refs.observacionesModal.hide();
    },
    addPresupuesto(item) {
      this.showModalConfirm('¿Desea generar el presupuesto interno para el brief de diseño seleccionado?', 
        this.addPresupuestoByBrief.bind(this, item.id), 'Si', 
        null, 'No');
    },
    addPresupuestoByBrief(briefId) {
      this.showSpinner();
      this.$store.dispatch('presupuestointerno/addPresupuestoByBrief', briefId)
        .then(() => {
          this.showModalMsj('El presupuesto interno se generó con éxito.', this.getItems, this.getItems, 'light');
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    asociarPresupuesto(item) {
      this.briefId = item.id;
      this.$refs.searchPresupuestoInternoModal.show();
    },
    presupuestoInternoSeleccionado(params) {
      this.$refs.searchPresupuestoInternoModal.hide();

      let briefParams = {
        briefId: this.briefId,
        presupuestoInternoId: params.presupuestoInterno.id
      }
      this.showSpinner();
      this.$store.dispatch('brief/asociarPresupuesto', briefParams)
        .then(() => {
          this.showModalMsj('El presupuesto interno se asoció con éxito.', this.getItems, this.getItems, 'light');
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelaSeleccionPresupuestoInterno() {
      this.$refs.searchPresupuestoInternoModal.hide()
    },
    asignarUsuarios(item) {
      this.briefId = item.id;
      this.$refs.usuariosSeleccionModal.show();
    },
    closeUsuariosSeleccion() {
      this.$refs.usuariosSeleccionModal.hide();
    },
    abrir(item) {
      this.showModalConfirm('¿Desea abrir el brief de diseño seleccionado?', 
        this.abrirBrief.bind(this, item.id), 'Si', 
        null, 'No');
    },
    abrirBrief(briefId) {
      this.showSpinner();
      this.$store.dispatch('briefs/abrirBrief', briefId)
        .then(() => this.showModalMsj('El brief de diseño se actualizó con éxito.', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cerrar(item) {
      this.showModalConfirm('¿Desea cerrar el brief de diseño seleccionado?', 
        this.cerrarBrief.bind(this, item.id), 'Si', 
        null, 'No');
    },
    cerrarBrief(briefId) {
      this.showSpinner();
      this.$store.dispatch('briefs/cerrarBrief', briefId)
        .then(() => this.showModalMsj('El brief de diseño se actualizó con éxito.', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportar() {
      this.showSpinner();
      this.$store.dispatch('briefs/getList')
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptBriefs = this.$store.getters['briefs/list'];

          if (rptBriefs) {
            if (rptBriefs.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Listado de Briefs';
            let fileName = 'briefs';
            let format = [
              { titulo: 'Nro.Brief', nombre: 'id', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fechaHora' },
              { titulo: 'Fecha Ult. Modificación', nombre: 'fechaUltimaEdicion', formato: 'fechaHora' },
              { titulo: 'Nro.Presup.', nombre: 'presupuestosInternosNumeros', formato: '' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Creador Por', nombre: 'usuario', formato: '' },
              { titulo: 'Cerrado', nombre: 'isCerrado', formato: 'bool' }
            ];

            this.exportXLS(title, fileName, rptBriefs, format);
            
          } else {
            this.showErrorMsj ('No hay datos para exportar.');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .briefs-list .registro {
    min-height: 500px;
  }
  .briefs-list .registro table td[aria-colindex="1"] {
    width: 5%;
  }
  .briefs-list .registro table td[aria-colindex="2"] {
    width: 10%;
    /* width: 12%; */
  }
  .briefs-list .registro table td[aria-colindex="3"] {
    width: 10%;
    /* width: 12%; */
  }
  .briefs-list .registro table td[aria-colindex="4"] {
    width: 8%;
  }
  .briefs-list .registro table td[aria-colindex="5"] {
    width: calc(25% - 30px);
  }
  .briefs-list .registro table td[aria-colindex="6"] {
    width: calc(30% - 30px);
  }
  .briefs-list .registro table td[aria-colindex="7"] {
    width: 12%;
    /* width: 8%; */
  }
  .briefs-list .registro table td[aria-colindex="8"] {
    width: 30px;
  }
  .briefs-list .registro table td[aria-colindex="9"] {
    width: 30px;
  }
</style>
